import * as React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { runAusgabeFibu, runEinlesenFibu } from 'api/bmd';
import { getTheme, ITheme, mergeStyleSets } from '@fluentui/react/lib/Styling';
import classnames from 'classnames';
import nl2br from 'react-nl2br';

const theme: ITheme = getTheme();
const { palette } = theme;

const styles = mergeStyleSets({
    container: {
        margin: 0,
        marginTop: 5,
        padding: 0,
        display: 'grid',
        gridTemplateRows: 'max-content 1fr',
        gridRowGap: 5,
        height: 'calc(100vh - 75px)',
    },
    actionButtons: {
        marginTop: 29,
        display: 'grid',
        gridTemplateColumns: 'repeat(2, max-content)',
        gridColumnGap: 10,
    },
    resultContainer: {
        overflowY: 'auto',
    },
    error: {
        color: palette.red,
    },
    result: {
        color: palette.green,
    },
});

export const BmdView: React.FC = () => {
    const [ausgabeFibuStarted, setAusgabeFibuStarted] = React.useState(false);
    const [einlesenFibuStarted, setEinlesenFibuStarted] = React.useState(false);
    const [error, setError] = React.useState<string | null>(null);
    const [result, setResult] = React.useState<string | null>(null);

    return (
        <div className={styles.container}>
            <div className={styles.actionButtons}>
                <PrimaryButton
                    disabled={ausgabeFibuStarted}
                    onClick={async () => {
                        setError(null);
                        setResult('Rechnungen und Kunden werden exportiert...');
                        setAusgabeFibuStarted(true);
                        try {
                            const result2 = await runAusgabeFibu();
                            setResult(
                                'Exportierte Rechnungen: ' +
                                    result2.anzahlRechnungen.toString() +
                                    '\n' +
                                    'Exportierte Kunden: ' +
                                    result2.anzahlKunden.toString(),
                            );
                        } catch (error2) {
                            console.error(error2);
                            setError(error2.message);
                            setAusgabeFibuStarted(false);
                        }
                    }}
                    text="Ausgabe FIBU"
                />
                <PrimaryButton
                    disabled={einlesenFibuStarted}
                    onClick={async () => {
                        setError(null);
                        setResult('Rechnungen werden eingelesen...');
                        setEinlesenFibuStarted(true);
                        try {
                            const result2 = await runEinlesenFibu();
                            setResult(
                                'Offene Rechnungen: ' +
                                    result2.anzahlRechnungenOffen.toString() +
                                    '\n' +
                                    'Bezahlte Rechnungen: ' +
                                    result2.anzahlRechnungenBezahlt.toString() +
                                    '\n' +
                                    'Probleme: (' +
                                    result2.rechnungenNotFound.length +
                                    '):\n' +
                                    result2.rechnungenNotFound.join('\n'),
                            );
                        } catch (error2) {
                            console.error(error2);
                            setError(error2.message);
                            setEinlesenFibuStarted(false);
                        }
                    }}
                    text="Einlesen FIBU"
                />
            </div>
            <div className={styles.resultContainer}>
                {error && <div className={classnames(styles.error, 'code')}>{nl2br(error)}</div>}
                {result && <div className={styles.result}>{nl2br(result)}</div>}
            </div>
        </div>
    );
};
